import { useMemo } from 'react';
import { FloorplanListData } from 'src/components/agile/zoneViewer/zoneMapDataType';
import { GetFloorplanInput, useGetFloorplanQuery } from 'src/graphql/generated/graphql';

// Stable empty reference: when the service returns no floorplans (`floorplans: null`),
// a fresh `[]` on every render would retrigger every effect/memo keyed on floorplanList.
const EMPTY_FLOORPLAN_LIST: FloorplanListData[] = [];

const useGetFloorplan = (input: GetFloorplanInput) => {
  const { data, isSuccess, isLoading } = useGetFloorplanQuery(
    {
      input,
    },
    {
      // disable refetchOnWindowFocus so that data is not refreshed
      // when user leave the page and come back
      refetchOnWindowFocus: false,
    },
  );

  const floorplanList: FloorplanListData[] = useMemo(
    () => data?.getFloorplan.floorplans ?? EMPTY_FLOORPLAN_LIST,
    [data],
  );

  return {
    floorplanList,
    isSuccess,
    isLoading,
  };
};

export default useGetFloorplan;
